import React, { Component } from 'react';
import Slider from 'react-slick';

import Button from '../../../blocks/button/Button';

import './style.css';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <Button styleClasses={['slide-arrow slide-arrow_right']} />,
  prevArrow: <Button styleClasses={['slide-arrow slide-arrow_left']}/>,
  autoplay: true
};

export default class SliderLanding extends Component {
  render() {
    return (
      <div className='slider-small'>
        {/*<div className='slider__title'>Как это было?</div>*/}
        <Slider {...settings}>
          <div><img src='' alt='' className='slider-small__img slider__img_01' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_02' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_03' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_04' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_05' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_06' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_07' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_08' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_09' /></div>
          <div><img src='' alt='' className='slider-small__img slider__img_10' /></div>
        </Slider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/slider/SliderSmall.js